import { LoggerFactory } from '@cvent/logging/LoggerFactory';

export const LOG = LoggerFactory.create('localStorageUtilities');
/**
 * Set local storage without the use of React state.
 * It will JSON strigify your value by default, but it can be skipped.
 */
export const setLocalStorage = (key: string, value, options = { skipJsonStringify: false }) => {
  try {
    // Check if window is defined for avoiding any error/warning when the page is server side rendered
    if (typeof window !== 'undefined') {
      return localStorage.setItem(key, options.skipJsonStringify ? value : JSON.stringify(value));
    }
  } catch (exception) {
    LOG.warn('Unable to set value to local storage', exception);
  }
  return null;
};

/**
 * Get an item from local storage without the use of React state.
 */
export const getLocalStorage = (key: string) => {
  try {
    // Check if window is defined for avoiding any error/warning when the page is server side rendered
    if (typeof window !== 'undefined') {
      return localStorage.getItem(key);
    }
  } catch (exception) {
    LOG.warn('Unable to get value from local storage', exception);
  }
  return null;
};
